import { Pressable, StyleSheet, View, ViewProps } from 'react-native';
import { useTranslation } from 'react-i18next';

import { InputErrors, Text, colors, spacing } from '@pletly/ui';
import ChevronDownIcon from '%assets/icons/chevron-down.svg';
import PrivacyIcon from './language.svg';

export const PostPrivacyButtonWeb = ({
	onPress,
	selectedUsersInfoText,
	disabled = false,
	errors = [],
	style,
	...viewProps
}: Props) => {
	const { t } = useTranslation();

	const isValid = errors.length === 0;

	return (
		<View {...viewProps} style={[styles.root, style]}>
			<Pressable
				style={[styles.buttonContainer, !isValid && styles.errorBorder]}
				onPress={onPress}
				disabled={disabled}
			>
				<View style={styles.iconContainer}>
					<PrivacyIcon />
				</View>

				<View style={styles.privacyInfoText}>
					<Text category="c2" numberOfLines={1}>{`${t(
						'post.new.publish',
					)}: ${selectedUsersInfoText}`}</Text>
					<View style={styles.iconContainer}>
						<ChevronDownIcon />
					</View>
				</View>
			</Pressable>
			{!isValid && <InputErrors errors={errors} />}
		</View>
	);
};

type Props = {
	onPress: () => void;
	selectedUsersInfoText: string;
	disabled?: boolean;
	errors?: string[];
} & ViewProps;

const styles = StyleSheet.create({
	root: {
		marginTop: spacing(),
		marginBottom: spacing(2),
	},
	buttonContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing(),
		paddingHorizontal: spacing(2),
		paddingVertical: spacing(),
		backgroundColor: colors.neutral300,
		borderRadius: 8,
		alignSelf: 'flex-start',
		maxWidth: '100%',
	},
	privacyInfoText: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing(0.5),
		flex: 1,
		minWidth: 75,
	},
	errorBorder: {
		borderColor: colors.accent,
		borderWidth: 1,
	},
	iconContainer: {
		width: 24,
		height: 24,
		alignItems: 'center',
		justifyContent: 'center',
	},
});
